<template>
  <div class="main_box">
    <el-radio-group
      v-model="watchTarget"
      size="small"
      style="margin: 15px 0px 0px 0px"
      @change="changeWatch()"
    >
      <el-radio-button label="progress"> 监控 </el-radio-button>
      <el-radio-button label="result">结果</el-radio-button>
      <el-radio-button label="details" v-show="questionnaireInfo.Type === 2">
        明细
      </el-radio-button>
    </el-radio-group>
    <router-view :questionnaireInfo="questionnaireInfo" />
  </div>
</template>
<script>
import questionnaireApi from '../../../../../api/wj/questionnaire'
export default {
  name: 'watch',
  components: {
  },
  data () {
    return {
      watchTarget: 'progress',
      questionnaireInfo: {
        Type: -1,
        State: null,
        MeetingVerify: 1
      }
    }
  },
  methods: {
    changeWatch: function () {
      switch (this.watchTarget) {
        case 'progress':
          if (this.questionnaireInfo.Type === 1) {
            this.$router.push({ name: 'questionnaireProgress', params: { mid: this.$route.params.mid, qid: this.$route.params.qid } })
          }
          if (this.questionnaireInfo.Type === 2) {
            this.$router.push({ name: 'voteQuestionnaireProgress', params: { mid: this.$route.params.mid, qid: this.$route.params.qid } })
          }
          break
        case 'result':
          if (this.questionnaireInfo.Type === 1) {
            this.$router.push({ name: 'questionnaireResult', params: { mid: this.$route.params.mid, qid: this.$route.params.qid } })
          }
          if (this.questionnaireInfo.Type === 2) {
            this.$router.push({ name: 'votQuestionnaireResult', params: { mid: this.$route.params.mid, qid: this.$route.params.qid } })
          }
          break
        case 'details':
          if (this.questionnaireInfo.Type === 1) {
            this.$router.push({ name: 'questionnaireDetails', params: { mid: this.$route.params.mid, qid: this.$route.params.qid } })
          } if (this.questionnaireInfo.Type === 2) {
            this.$router.push({ name: 'voteQuestionnaireDetails', params: { mid: this.$route.params.mid, qid: this.$route.params.qid } })
          }
          break
      }
    },
    getQuestionnaireInfo: function () {
      const _this = this
      if (_this.$route.params.qid !== '0') {
        questionnaireApi.getQuestionnaireDetail({
          questionnaireId: _this.$route.params.qid
        }).then(data => {
          _this.questionnaireInfo = data
          if (this.$route.name === 'questionnaireProgress') {
            this.watchTarget = 'progress'
          } else if (this.$route.name === 'questionnaireResult') {
            this.watchTarget = 'result'
          } else if (this.$route.name === 'questionnaireDetails') {
            this.watchTarget = 'details'
          } else if (this.$route.name === 'voteQuestionnaireProgress') {
            this.watchTarget = 'progress'
          } else if (this.$route.name === 'votQuestionnaireResult') {
            this.watchTarget = 'result'
          } else if (this.$route.name === 'voteQuestionnaireDetails') {
            this.watchTarget = 'details'
          } else {
            this.changeWatch()
          }
        }).catch(err => {
          return err
        })
      } else {
        _this.questionnaireInfo.State = 0
      }
    }
  },
  computed: {

  },
  created () {
    this.getQuestionnaireInfo()
  }
}
</script>
<style lang="less">
</style>
